// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2dLLD","choiceBoxes":"toolbarselects_choiceBoxes__36Xlc","simpleField":"toolbarselects_simpleField__3W4TO"};